import { apiPost } from "./api";
import { Analytics } from "./analytics";

$(document).ready(function () {
    const saveCardIframe = document.getElementById('save-card-iframe');
    const makeCardDefaultButton = document.querySelector('button[data-ticketing][name="set-default-card"]');

    if (makeCardDefaultButton) {
        makeCardDefaultButton.addEventListener('click', (e) => {
            makeCardDefaultButton.disabled = true;

            apiPost('mark-card-as-default', {
                cardHash: makeCardDefaultButton.getAttribute('data-card')
            }).finally(() => {
                window.location.reload();
            });
        });
    }

    document.querySelectorAll('button[data-ticketing][name="remove-card"]').forEach((removeCardButton) => {
        removeCardButton.addEventListener('click', (e) => {
            removeCardButton.disabled = true;

            apiPost('remove-card', {
                cardHash: removeCardButton.getAttribute('data-card')
            }).then((resp) => {
                window.location.reload();
            }).catch((error) => {
                removeCardButton.disabled = false;
            });
        });
    })

    if (saveCardIframe) {
        window.addEventListener('message', (e) => {
            const message = e.data;
            if (typeof message === 'string') {
                const messageParts = e.data.split('/');
                const messageType = messageParts[0];
                const messageData = messageParts[1];

                const params = new URLSearchParams(window.location.search.substring(1));
                let redirect = '/my-cards';

                if (params.has('returnTo')) {
                    const returnTo = params.get('returnTo');
                    if (returnTo && returnTo[0] === '/') {
                        redirect = returnTo;
                    }
                }

                switch (messageType) {
                    case 'card-saved':
                        apiPost('mark-card-as-default', {
                            cardId: messageData
                        }).finally(() => {
                            Analytics.addPaymentInfo();
                            saveCardIframe.parentElement.removeChild(saveCardIframe);

                            window.location.href = redirect;
                        });
                        break;

                    case 'card-cancelled':
                        saveCardIframe.parentElement.removeChild(saveCardIframe);
                        window.location.href = redirect;
                        break;
                }
            }
        });
    }
});